import { Logger } from '@nvision/services/logger';

export const logger = new Logger({ prefix: 'procurement' });
